import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
import React from 'react';
import DesktopAdhesionGak from './gak/DesktopAdhesion';
import DesktopAdhesionHashtag from './hashtag/DesktopAdhesion';
const DesktopAdhesion = ({ safety = 'off', safetyState })=>{
    const isHashtag = useFlag('ads_prebid');
    if (isHashtag) {
        return /*#__PURE__*/ React.createElement(DesktopAdhesionHashtag, {
            safety: safety,
            safetyState: safetyState
        });
    }
    return /*#__PURE__*/ React.createElement(DesktopAdhesionGak, {
        safety: safety,
        safetyState: safetyState
    });
};
DesktopAdhesion.displayName = 'DesktopAdhesion';
export default DesktopAdhesion;
